import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { GTMService } from 'src/app/services/gtm.service';

@Component({
  selector: 'invitation-accepted',
  providers: [GTMService],
  styleUrls: ['./invitation-accepted.component.scss'],
  template: `
    <div class="invitation-card">
      <overlay-loading *ngIf="loading"></overlay-loading>

      <div class="invites-container" [class.full-height]="myInvites.length">
        <div class="card-title">Convites aceitos</div>

        <div *ngIf="!myInvites.length" class="without-invitations">
          Quando alguém aceitar o seu convite, aparecerá listado aqui para você acompanhar.
        </div>

        <div *ngFor="let invite of myInvites" class="invitation-item">
          <div class="invitation-info">
            <b>{{invite.receiverName}}</b>
            Aceito em: {{invite.created_at | date:"dd/MM/yy"}}
          </div>
          <div class="status">
            <span class="fa fa-check"></span>
            Aceito
          </div>
        </div>
      </div>
      <button *ngIf="myInvites.length && !hideButton" (click)="redirectToInvites()" class="btn">Ver todos</button>
    </div>
  `
})

export class InvitationAcceptedComponent {
  @Input()
  loading: boolean;

  @Input()
  hideButton: boolean;

  @Input()
  limit: number;

  @Input()
  set invites(invites: any[]) {
    this.myInvites = (invites || [])
      .sort(this.dateSort)
      .slice(0, this.limit);
  }

  myInvites: any[] = [];

  constructor(
    private gtm: GTMService,
    private router: Router
  ) { }

  dateSort(...invites) {
    const dates = invites.map(invite => new Date(invite.created_at));
    if (dates[0] > dates[1]) return -1;
    if (dates[0] < dates[1]) return 1;
    return 0;
  }

  redirectToInvites() {
    this.gtm.interaction('allya:mgm', 'mgm:click', 'ver-todos:convites');
    this.router.navigate(['/convites']);
  }
}
